	<script>
	import { afterUpdate } from "svelte";
	import Analytics from "./Analytics/Analytics";
	import './App.scss';
	import AppStore from "./AppStore";
	import AuthState from "./Auth/Enums/AuthState";
	import LoginPanel from "./Auth/LoginPanel.svelte";
	import AuthStore from "./Auth/Store";
	import Feature from "./Branding/Feature";
	import User from "./Branding/User";
	import './Global.scss';
	import UIHelper from "./Helpers/UIHelper";
	import Hotkeys from "./IO/Hotkeys.js";
	import HotkeysModal from "./IO/HotkeysModal.svelte";
	import CustomDatasets from "./Map/CustomDatasets.svelte";
	import CustomMapDatasets from "./Map/CustomMapDatasets";
	import MapControlType from "./Map/Enums/MapControlType";
	import Map from "./Map/Map.svelte";
	import MapControls from "./Map/MapControls.svelte";
	import { Paint } from "./Map/MapLayerStyles";
	import MapStore from "./Map/Store";
	import OAuthStore from "./OAuth/Store";
	import TimezoneController from "./TimeZoneOverlay/TimezoneController.svelte";
	import Annotations from "./UI/Annotations/Annotations.svelte";
	import MaritimeBoundaries from "./UI/MaritimeBoundaries/MaritimeBoundaries.svelte";
	import MARMANs from "./UI/MARMANs/MARMANs.svelte";
	import PortAssessments from "./UI/PortAssessments.svelte";
	import PortsView from "./UI/Ports/Ports.svelte";
	import PortsStore from "./UI/Ports/Store";
	import UKHOWind from "./UKHO/Wind.svelte";
// import COVID19 from "./COVID19/COVID19.svelte";
	// import COVID19Store from "./COVID19/COVID19Store";
	// import AGOLTestWindow from "./UI/AGOL/AGOLTestWindow.svelte";

	import Banner from "./UI/Banner/Banner.svelte";
	import FlyoutMenu from "./UI/FlyoutMenu/FlyoutMenu.svelte";
	import MaritimeFeatures from "./UI/MaritimeFeatures/MaritimeFeatures.svelte";
	import VesselHistory from "./UI/VesselHistory/VesselHistory.svelte";
	import VesselsNearbyStore from "./UI/VesselsNearby/Store";
	import VesselsNearby from "./UI/VesselsNearby/VesselsNearby.svelte";
// TODO: Store.

	import Button from '@smui/button';
	import Paper,{ Content,Title } from '@smui/paper';
	import Tab,{ Label } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import { onMount } from "svelte";
	import AlertsController from "./Alerts/AlertsController.svelte";
	import AlertsStore from "./Alerts/Store";
	import AppMenuTab from './AppMenuTab';
	import Aircraft from "./Aviation/Aircraft.svelte";
	import AircraftHistory from './Aviation/AircraftHistory.svelte';
	import AviationAlerts from './Aviation/AviationAlerts.svelte';
	import GNSSHotspots from './Aviation/GNSSHotspots/GNSSHotspots.svelte';
	import NOTAMS from "./Aviation/NOTAMS.svelte";
	import IdentityData from './Branding/IdentityData';
	import LoadState from "./Enums/LoadState";
	import SatCapView from "./Environment/SatCap/View.svelte";
	import SatRFView from "./Environment/SatRF/View.svelte";
	import VideoSatView from "./Environment/Video/View.svelte";
	import LoadingStore from "./LoadingStore";
	import MapLayerGroup from './Map/Enums/MapLayerGroup';
	import MaritimeMenuTab from './MaritimeMenuTab';
	import SanctionsController from "./Sanctions/SanctionsController.svelte";
	import ShippingLanes from "./ShippingLanes/ShippingLanes.svelte";
	import CMS from "./UI/Admin/CMS.svelte";
	import FormSnackbar from "./UI/Admin/FormSnackbar.svelte";
	import CoordinatePane from "./UI/CoordinatePane/CoordinatePane.svelte";
	import CustomGeoJSONOverlayForm from "./UI/CustomGeoJSONOverlayForm/CustomGeoJSONOverlayForm.svelte";
	import EditGeoJSONOverlayForm from "./UI/CustomGeoJSONOverlayForm/EditForm.svelte";
	import CompanyDashboard from "./UI/Dashboards/Company/View.svelte";
	import UserPreferencesDashboard from "./UI/Dashboards/UserPreferences/View.svelte";
	import FaviconMunge from "./UI/FaviconMunge.svelte";
	import LoadingSnackbar from "./UI/LoadingSnackbar/LoadingSnackbar.svelte";
	import Hotspots from './UI/Hotspots/Hotspots.svelte';
	import HydrographicCharts from "./UI/HydrographicCharts/HydrographicCharts.svelte";
	import ImageCollections from "./UI/ImageCollections/ImageCollections.svelte";
	import InfoCard from "./UI/InfoCard/InfoCard.svelte";
	import LogoMunge from "./UI/LogoMunge/LogoMunge.svelte";
	import MaritimeIncidentsView from "./UI/MaritimeIncidents/View.svelte";
	import RoutePlotWindow from './UI/MeasureTool/RoutePlotWindow.svelte';
	import ModalWindow from './UI/ModalWindow.svelte';
	import CablesWindow from './UI/NationalGrid/CablesWindow.svelte';
	import NotepadWindow from './UI/Notepad/NotepadWindow.svelte';
	import RiskIntIncidents from './UI/RiskInt/RiskIntIncidents.svelte';
	import RiskIntPorts from './UI/RiskInt/RiskIntPorts.svelte';
	import RoutingWindow from './UI/Routing/RoutingWindow.svelte';
	import SatelliteViewController from "./UI/SatelliteView/Controller.svelte";
	import SearchBarMunge from "./UI/SearchBarMunge.svelte";
	import Spinner from "./UI/Spinner/Spinner.svelte";
	import SpinnerSize from "./UI/Spinner/SpinnerSize";
	import TitleMunge from "./UI/TitleMunge.svelte";
	import VersionMunge from "./UI/VersionMunge.svelte";
	import EarthquakesController from "./Weather/EarthquakesController.svelte";
	import HurricanesController from "./Weather/HurricanesController.svelte";
	import Weather from "./Weather/Weather.svelte";

	let alertsLoadState = AlertsStore.meta.loadState;
	let alertsUpdateState = AlertsStore.meta.updateState;
	let vesselsNearbyLoadState = VesselsNearbyStore.meta.loadState;
	let mapInitialised = MapStore.meta.initialised;

	let lastUpdatedVisible = false;
	$: {
		lastUpdatedVisible = $alertsLoadState == LoadState.LOADED;
	}

	let globalLoading = LoadingStore.loading;
	onMount(()=>{
		LoadingStore.add("volcanoes", AppStore.hazards.volcanoes.meta.loadState);
		LoadingStore.add("earthquakes", AppStore.hazards.earthquakes.meta.loadState);
		LoadingStore.add("floods", AppStore.hazards.floods.meta.loadState);
		LoadingStore.add("port_assessments", AppStore.portAssessments.meta.loadState);
		LoadingStore.add("ports", PortsStore.meta.loadState);
		LoadingStore.add("miss", AppStore.miss.meta.loadState);
		return () => {
			LoadingStore.remove("volcanoes");
			LoadingStore.remove("earthquakes");
			LoadingStore.remove("floods");
			LoadingStore.remove("port_assessments");
			LoadingStore.remove("ports");
			LoadingStore.remove("miss");
		}
	});

	let loginState = AuthStore.meta.state;

	onMount(() => {
		AuthStore.actions.init();
		AlertsStore.actions.init();
		Analytics.init();
		// Router.run();
	});

	AuthStore.userInfo.subscribe(userInfo => {
		Analytics.set({ user_id: userInfo.username });
	});

	let themeName = "default"; //AppStore.theme;
	AuthStore.userInfo.subscribe((userInfo) => {
		themeName = (userInfo.identity.length > 0) ? userInfo.identity : "default";
	});

	// Make sure the user stays logged in so that API requests are never valid invalid.
	MapStore.meta.initialised.subscribe((initialised)=>{
		if (initialised) {
			PortsStore.actions.init();
			setInterval(AuthStore.actions.pingSession, 4 * 60 * 1000);
		}
	});

	let menuVisible = AppStore.menu.visible;

	let activeMenuTab = AppStore.menu.tab;
	let mainMenuTabs = [];

	let activeMaritimeMenuTab = AppStore.menu.maritime.tab;
	let maritimeMenuTabs = [];

	let activeAviationMenuTab = AppStore.menu.aviation.tab;
	let aviationMenuTabs = [];

	let activeEnvironmentMenuTab = AppStore.menu.environment.tab;
	let environmentMenuTabs = [];

	let updateTabs = (forceTabReset = false) => {
		mainMenuTabs = [AppMenuTab.MARITIME];
		if (User.hasFeature(Feature.AVIATION.VIEW)) {
			mainMenuTabs.push(AppMenuTab.AVIATION);
		}
		if (User.hasFeature(Feature.ENVIRONMENT.VIEW)) {
			mainMenuTabs.push(AppMenuTab.ENVIRONMENT);
		}
		if (CustomMapDatasets.countPublic() > 0) {
			mainMenuTabs.push(AppMenuTab.CUSTOM_DATASETS);
		}
		if ($activeMenuTab === "") {
			$activeMenuTab = mainMenuTabs[0];
			mainMenuTabs = mainMenuTabs;
		}

		// Maritime
		maritimeMenuTabs = [];
		if (User.hasFeature(Feature.ALERTS.VIEW)) {
			maritimeMenuTabs.push(MaritimeMenuTab.ALERTS);
		};
		if (User.hasFeature(Feature.VESSEL_HISTORY.VIEW)) {
			maritimeMenuTabs.push(MaritimeMenuTab.VESSEL_HISTORY);
		}
		if (User.hasFeature(Feature.VESSELS_NEARBY.VIEW)) {
			maritimeMenuTabs.push(MaritimeMenuTab.VESSELS_NEARBY);
		}
		if (User.hasFeature(Feature.MARITIME.UKHO.FEATURES.VIEW)) {
			maritimeMenuTabs.push(MaritimeMenuTab.FEATURES);
		}

		if ($activeMaritimeMenuTab === "" || forceTabReset) {
			$activeMaritimeMenuTab = maritimeMenuTabs[0];
			maritimeMenuTabs = maritimeMenuTabs;
		}

		environmentMenuTabs = [];
		if (User.hasFeature(Feature.ENVIRONMENT.VIEW)) {
			environmentMenuTabs.push("Point");
		}
		// environmentMenuTabs.push("Videosat");
		if ($activeEnvironmentMenuTab === "" || forceTabReset) {
			$activeEnvironmentMenuTab = environmentMenuTabs[0];
			environmentMenuTabs = environmentMenuTabs;
		}

		// Aviation
		aviationMenuTabs = [];
		if (User.hasFeature(Feature.AVIATION.ALERTS.VIEW)) {
			aviationMenuTabs.push("Alerts");
		}
		if (User.hasFeature(Feature.AVIATION.AIRCRAFT_HISTORY.VIEW)) {
			aviationMenuTabs.push("History");
		};
		if (User.hasFeature(Feature.AVIATION.DUMMY_DATA.VIEW)) {
			aviationMenuTabs.push("Aircraft (Sample)");
		}
		if ($activeAviationMenuTab === "" || forceTabReset) {
			$activeAviationMenuTab = aviationMenuTabs[0];
			aviationMenuTabs = aviationMenuTabs;
		}
	};

	afterUpdate(()=>{
		updateTabs();
	});

	AuthStore.userInfo.subscribe(() => { updateTabs(true); });

	CustomMapDatasets.lastUpdated.subscribe((time)=>{
		if (time !== 0) updateTabs();
	});





	// Setup Hotkeys
	let hotkeysOpen = false;
	AuthStore.userInfo.subscribe((data) => {
		Hotkeys.removeAll();
		Hotkeys.create({name: "Toggle Menu", code: "KeyM", event: () => {
			$menuVisible = !$menuVisible;
		}});
		// if (User.hasFeature(Feature.NOTEPAD.VIEW) || User.hasFeature(Feature.MEASURE.VIEW)) {
		// 	Hotkeys.create({name: "Toggle Toolbox", code: "KeyT", event: () => {
		// 		$toolsVisible = !$toolsVisible;
		// 	}});
		// }
		if (User.hasFeature(Feature.ALERTS.VIEW)) {
			Hotkeys.create({name: "Alerts (Tab)", code: "KeyA", event: () => {
				if (!$menuVisible) $menuVisible = true;
				$activeMenuTab = AppMenuTab.MARITIME;
				$activeMaritimeMenuTab = MaritimeMenuTab.ALERTS;
			}});
		}
		if (User.hasFeature(Feature.VESSEL_HISTORY.VIEW)) {
			Hotkeys.create({name: "History (Tab)", code: "KeyH", event: () => {
				if (!$menuVisible) $menuVisible = true;
				$activeMenuTab = AppMenuTab.MARITIME;
				$activeMaritimeMenuTab = MaritimeMenuTab.VESSEL_HISTORY;
			}});
		}
		if (User.hasFeature(Feature.VESSELS_NEARBY.VIEW)) {
			Hotkeys.create({name: "Nearby (Tab)", code: "KeyN", event: () => {
				if (!$menuVisible) $menuVisible = true;
				$activeMenuTab = AppMenuTab.MARITIME;
				$activeMaritimeMenuTab = MaritimeMenuTab.VESSELS_NEARBY;
			}});
		}
		if (User.hasFeature(Feature.ENVIRONMENT.VIEW)) {
			Hotkeys.create({name: "Environment (Tab)", code: "KeyW", event: () => {
				if (!$menuVisible) $menuVisible = true;
				$activeMenuTab = AppMenuTab.ENVIRONMENT;
			}});
		}
		Hotkeys.create({name: "Map: 'Pan'", code: "KeyP", event: () => {
			MapStore.control.set(MapControlType.PAN);
		}});
		Hotkeys.create({name: "Map: 'Box Select'", code: "KeyB", event: () => {
			MapStore.control.set(MapControlType.BOX_SELECT);
		}});
		Hotkeys.create({name: "Map: 'LngLat Picker'", code: "KeyL", event: () => {
			MapStore.control.set(MapControlType.LNGLAT_PICKER);
		}});
		Hotkeys.create({name: "Toggle Hotkey Overlay", code: "Space", event: () => {
			hotkeysOpen = !hotkeysOpen;
		}});
	});

	// ^AG: Filthy hacks...
	onMount(() => {
		OAuthStore.init();

		let safariFixHeights = () => {
			let overlay = document.getElementById("map-overlay");
			if (overlay) {
				overlay.style.height = (window.innerHeight - UIHelper.getBannerHeight()) + "px";
			}
		}
		window.addEventListener("load", safariFixHeights);
		window.addEventListener("resize", safariFixHeights);

		// Set up Volcanoes layer.
		const PopupElementType = {
			TITLE: "title",
			DESCRIPTION: "description",
			DATE: "date",
			KEYPAIR: "keypair"
		};
		AppStore.hazards.volcanoes.setMapLayerGroup( MapLayerGroup.HAZARDS_VOLCANOES );
		AppStore.hazards.volcanoes.addDataLayer({ url: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services/GENERAL_Volcanoes_LIVE_V1_view/FeatureServer" });
		AppStore.hazards.volcanoes.events.onLoaded.add((responses) => {
			AppStore.hazards.volcanoes.addDisplayLayer("volcanoes", "circle", Paint.hazards.volcanoes, responses[0]);
			AppStore.hazards.volcanoes.setDisplayLayerPopups("volcanoes", [
				{
					key: "Title",
					type: PopupElementType.TITLE,
					linkKey: "Link"
				},
				{
					key: "pubDate",
					type: PopupElementType.DATE
				},
				{
					key: "Description",
					type: PopupElementType.DESCRIPTION,
					maxLength:300
				}
			],{
				linkKey: "Link"
			});
		});

		// Set up earthquakes layer.
		AppStore.hazards.earthquakes.config.verbose = true;
		AppStore.hazards.earthquakes.setMapLayerGroup( MapLayerGroup.HAZARDS_EARTHQUAKES );
		AppStore.hazards.earthquakes.addDataLayer({
			url: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services/GENERAL_Earthquakes_LIVE_V1_view/FeatureServer"
		}, {
			orderByFields: ["Last_Updated DESC"],
			where: "1 = 1", // "Last_Updated > " + (Math.floor(Date.now()/1000) - (86400*30)),
			returnGeometry: true,
			outFields: ["Title", "Last_Updated", "Event_Date", "Link"]
		});
		AppStore.hazards.earthquakes.events.onLoaded.add((responses) => {
			AppStore.hazards.earthquakes.addDisplayLayer("earthquakes", "circle", Paint.hazards.earthquakes, responses[0]);
			AppStore.hazards.earthquakes.setDisplayLayerPopups("earthquakes", [
				{
					key: "Title",
					type: PopupElementType.TITLE,
					linkKey: "Link"
				},
				{
					key: "Event_Date",
					type: PopupElementType.DATE
				}
			],{
				linkKey: "Link"
			});
		});

		// Set up floods layer.
		AppStore.hazards.floods.setMapLayerGroup( MapLayerGroup.HAZARDS_FLOODS );
		AppStore.hazards.floods.addDataLayer({ url: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services/GENERAL_Floods_LIVE_V1_view/FeatureServer" });
		AppStore.hazards.floods.events.onLoaded.add((responses) => {
			AppStore.hazards.floods.addDisplayLayer("floods", "circle", Paint.hazards.floods, responses[0]);
			AppStore.hazards.floods.setDisplayLayerPopups("floods", [
				{
					key: "Title",
					type: PopupElementType.TITLE,
					linkKey: "Link"
				},
				{
					key: "pubDate",
					type: PopupElementType.DATE
				},
				{
					key: "AlertLevel",
					name: "Alert Level",
					type: PopupElementType.KEYPAIR
				},
				{
					key: "Description",
					type: PopupElementType.DESCRIPTION,
					maxLength:300
				}
			],{
				linkKey: "Link"
			});
		});



		// Set up Port Assessments layer.
		AppStore.portAssessments.config.verbose = true;
		AppStore.portAssessments.setMapLayerGroup( MapLayerGroup.PORT_ASSESSMENTS );
		AppStore.portAssessments.addDataLayer({
			url: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services/Chevron_PortAssessments/FeatureServer"
		}, {
			orderByFields: ["AssessmentDate DESC"],
			where: "ThreatLevel IS NOT NULL", // "Last_Updated > " + (Math.floor(Date.now()/1000) - (86400*30)),
			returnGeometry: true,
			outFields: ["Name", "ThreatLevel", "AssessmentDate", "PortAssessmentURL"]
		});
		AppStore.portAssessments.events.onLoaded.add((responses) => {
			AppStore.portAssessments.addDisplayLayer("port_assessments", "circle", Paint.portAssessments, responses[0]);
			AppStore.portAssessments.setDisplayLayerPopups("port_assessments", [
				{
					key: "Name",
					type: PopupElementType.TITLE,
					linkKey: "Link"
				},
				{
					key: "ThreatLevel",
					type: PopupElementType.DESCRIPTION,
  					maxLength: 300
				},
				{
					key: "AssessmentDate",
					type: PopupElementType.DATE
				}
			],{
				linkKey: "PortAssessmentURL"
			});
		});

		// Set up MISS layer.
		AppStore.miss.config.verbose = true;
		AppStore.miss.setMapLayerGroup( MapLayerGroup.MISS );
		AppStore.miss.addDataLayer({
			url: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services/MISS_GeoniusLayer_15042021/FeatureServer"
		}, {
			orderByFields: ["DateofOccurenceTime DESC"],
			where: "NOT Source = 'fleetmon'",
			returnGeometry: true,
			outFields: [
				"Title", "IncidentDescription", "Waterbody", "TTW", "Aggressor", "DateofOccurenceTime", "CollectionDate", "Link", "Source"
			]
		});
		AppStore.miss.events.onLoaded.add((responses) => {
			AppStore.miss.addDisplayLayer("agol_miss", "circle", Paint.hazards.miss, responses[0]);
			AppStore.miss.setDisplayLayerPopups("agol_miss", [
				{
					key: "Title",
					name: "Title",
					type: PopupElementType.TITLE,
					linkKey: "Link"
				},
				{
					key: "IncidentDescription",
					name: "Description",
					type: PopupElementType.DESCRIPTION,
				},
				{
					key: "Aggressor",
					name: "Type of Crime",
					type: PopupElementType.KEYPAIR,
				},
				{
					key: "Waterbody",
					name: "Waterbody",
					type: PopupElementType.KEYPAIR,
				},
				{
					key: "TTW",
					name: "Occurrence in TTW",
					type: PopupElementType.KEYPAIR,
				},
				{
					key: "Source",
					name: "Source",
					type: PopupElementType.KEYPAIR,
					linkKey: "Link"
				},
				{
					key: "CollectionDate",
					name: "Collection Date",
					type: PopupElementType.DATE
				},
				{
					key: "DateofOccurenceTime",
					name: "Date of Occurence",
					type: PopupElementType.DATE
				}

			],{
				linkKey: "Link"
			});
		});

	});



	let previewingVesselCommentAttachments = AppStore.previewingVesselCommentAttachments;

	// import "../node_modules/bootstrap/scss/_variables.scss";
	// import "../node_modules/bootstrap/scss/mixins/_container.scss";
	// import "../node_modules/bootstrap/scss/_containers.scss";
	// import "../node_modules/bootstrap/scss/bootstrap-grid.scss";

	let form = "login";

</script>

<div class={"app " + themeName}>


	{#if $loginState === AuthState.LOGGED_IN}

		<Banner />

		<SanctionsController />
		<RiskIntIncidents />
		<RiskIntPorts />
		<TimezoneController />
		<HurricanesController />
		<EarthquakesController />
		<MaritimeIncidentsView />
		<ShippingLanes/>
		<MaritimeBoundaries/>
		<PortsView/>
		<SatelliteViewController/>
		<RoutePlotWindow />
		<RoutingWindow />
		<NotepadWindow/>

		<MARMANs/>
		<UKHOWind/>

		<PortAssessments/>
		<Annotations/>
		<Hotspots/>
		<GNSSHotspots/>
		<HydrographicCharts/>
		<ImageCollections/>
		<!-- <COVID19/> -->
		<!-- <AGOLTestWindow/> -->
		<NOTAMS/>
		<CMS/>
		<CompanyDashboard/>
		<UserPreferencesDashboard/>

		<CustomGeoJSONOverlayForm />

		<SatCapView/>
		<SatRFView/>
		<CablesWindow/>

		<EditGeoJSONOverlayForm />


		<HotkeysModal bind:open={hotkeysOpen} />

		{#each $previewingVesselCommentAttachments as attachment}
			<ModalWindow
				materialIcon={"image"}
				title={attachment.fileName}
				hasCloseButton={true}
				hasBackground={false}
				resizable={true}
				draggable={true}
				fullscreen={false}
				padding={true}
				open={true}
				on:close={()=>{
					let index = $previewingVesselCommentAttachments.indexOf(attachment);
					$previewingVesselCommentAttachments.splice(index, 1);
					$previewingVesselCommentAttachments = $previewingVesselCommentAttachments;
				}} >
				<div style={"text-align:center;height:100%;"}>
					<img src={attachment.url} alt={attachment.fileName} title={attachment.fileName} style={"width:auto;height:100%;"}/>
				</div>
			</ModalWindow>

		{/each}

		<Map>
			<LogoMunge />
			<VersionMunge />
		</Map>

		<div class="box">
			<FlyoutMenu bind:visible={$menuVisible}>
				{#if !$mapInitialised}
					<p style="text-align:center;margin:0px;margin-top:24px;overflow:auto;height:48px;">
						<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
					</p>
				{:else}
					<TabBar tabs={mainMenuTabs} let:tab bind:active={$activeMenuTab} class="border-shadow">
						<Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
					</TabBar>

					{#if $activeMenuTab === AppMenuTab.MARITIME}

						<TabBar tabs={maritimeMenuTabs} let:tab bind:active={$activeMaritimeMenuTab} class="thin border-shadow">
							<Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
						</TabBar>

						{#if $activeMaritimeMenuTab === MaritimeMenuTab.ALERTS}
							<AlertsController />
						{:else if $activeMaritimeMenuTab === MaritimeMenuTab.VESSEL_HISTORY}
							<VesselHistory />
						{:else if $activeMaritimeMenuTab === MaritimeMenuTab.VESSELS_NEARBY}
							<VesselsNearby />
						{:else if $activeMaritimeMenuTab === MaritimeMenuTab.FEATURES}
							<MaritimeFeatures />
						{/if}

					{:else if $activeMenuTab === AppMenuTab.AVIATION}
						<TabBar tabs={aviationMenuTabs} let:tab bind:active={$activeAviationMenuTab} class="thin border-shadow">
							<Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
						</TabBar>
						{#if $activeAviationMenuTab === "Alerts"}
							<AviationAlerts />
						{:else if $activeAviationMenuTab === "Aircraft (Sample)"}
							<Aircraft/>
						{:else if $activeAviationMenuTab === "History"}
							<AircraftHistory />
						{/if}
					{:else if $activeMenuTab === AppMenuTab.ENVIRONMENT}
						<TabBar tabs={environmentMenuTabs} let:tab bind:active={$activeEnvironmentMenuTab} class="thin border-shadow">
							<Tab tab={tab} minWidth><Label>{tab}</Label></Tab>
						</TabBar>

						{#if $activeEnvironmentMenuTab === "Point"}
							<Weather />
						{:else if $activeEnvironmentMenuTab === "Videosat"}
							<VideoSatView/>
						{/if}
					{:else if $activeMenuTab === AppMenuTab.CUSTOM_DATASETS}
						<CustomDatasets />
					{/if}
				{/if}
			</FlyoutMenu>
			<div id="map-overlay">
				<MapControls />
				<CoordinatePane />
				<InfoCard />
				<!-- <AircraftInfoCard /> -->
				<LoadingSnackbar visible={$globalLoading} />
				<FormSnackbar bind:this={AppStore.snackbar}/>
			</div>
			<!-- <FlyoutMenu visible={$toolsVisible} side="right">
				<TabBar tabs={toolTabs} let:tab bind:active={$activeToolTab} class="border-shadow">
					<Tab {tab} minWidth><Label>{tab}</Label></Tab>
				</TabBar>
				{#if $activeToolTab == "Toolbox"}
					<ExternalLinks/>
				{/if}
			</FlyoutMenu> -->
		</div>
		<TitleMunge />
		<FaviconMunge />
		<SearchBarMunge />
	{:else}
		<!-- <Banner /> -->

		<div id="landing-page-back">

		</div>
		<div id='landing-page-front'>
			<div id="login-panel">
				<div class='logo-container'>
					<img class="logo" src={IdentityData.geollect.logo} title={"Geonius"} alt={"Geonius"} style="width:100%;" />
				</div>
				<p class='tagline'>The Geospatial Intelligence Platform</p>
				<div class="nav-container">
					<Button variant="unelevated" color="primary" on:click={()=>{ form = "login"; }}>
						<Label>Login</Label>
					</Button>

					<Button variant="unelevated" on:click={()=>{ form = "contact"; }}>
						<Label>Contact</Label>
					</Button>
				</div>
				{#if form === "login"}
					<LoginPanel />
				{:else}
					<Paper color={"surface"} elevation={10} >
						<Title>Contact</Title>
						<Content>
							<p style="margin-bottom:20px;">"Three things motivate our work on Geonius; ensuring it meets your needs, being the best, and being transparent. Speak to us about why we believe our technical and intelligence expertise means we back our data driven, human-centred promise".<br/>
								-- Dr. Ryan Lloyd, Head of R&D</p>

							<p style="margin-bottom:20px;">For support, please email <a href='mailto:info@geollect.com'>info@geollect.com</a>.</p>

							<h4>UK Geollect Ltd</h4>
							<p style="margin-bottom:20px;">
								<b>E:</b> info@geollect.com
							</p>

							<h4>U.S. Geollect LLC</h4>
							<p style="margin-bottom:5px;">
								<b>E:</b> info.usa@geollect.com
							</p>

						</Content>
					</Paper>
				{/if}
				<p class='version'>{__VERSION}<br/><br/></p>

				<div style="width:100px; text-align:center; margin:0px auto;">
					<a href='https://geollect.com/' target='new'>
						<img style="width:100%; filter:invert(200%) sepia(0%) saturate(0%) brightness(120%) contrast(100%);" src='/img/homepage/Geollect-logo_no-strap.svg' alt='Geollect' />
					</a>
				</div>
				<p class='version copyright'>Geollect &copy; {(new Date()).getFullYear()} <a href='https://geollect.com/' target='new'>www.geollect.com</a></p>
			</div>
		</div>

		<!-- <div class='split-page'>
			<div class='split-page-left background-container'>
				<div class='split-page-left background'></div>
			</div>
			<div class='split-page-left content'>
				<img src='/img/homepage/Geollect-G_gradient.svg' style='width:20%' alt="Geonius"/>
				<h1 class='display-1'>GEONIUS™</h1>
				<p class='lead'>Know where, know first, know more.</p>

				<p>Made by <a href='https://www.geollect.com' target='new'>Geollect</a></p>
			</div>
			<div class='split-page-right '>
				<div class='content'>
					<div>
						<img class="logo" src={IdentityData.geollect.logo} title={"Geonius"} alt={"Geonius"} />
					</div>


					{#if !loginFormVisible}

						<button class='btn bg-primary btn-lg' on:click={() => {
							loginFormVisible = !loginFormVisible;
						}}>Login</button>

					{:else}
						<LoginPanel />
					{/if}
				</div>

			</div>
		</div> -->


		<!-- <div id="homepage-bg">&nbsp;</div>
		<div id="homepage">

			<div style='border-bottom:5px solid black;'>
				<div class='container'>
					<div class='row py-5'>
						<div class='col-12'>
							<center>
								<img src='/img/homepage/GeoniusBannerWordmark.png' style='min-width:350px; width:35%; height:auto;' alt="Geonius"/>
							</center>
						</div>
					</div>
				</div>
			</div>

			<div style='background-color:rgba(255,255,255,1.0);'>
				<div class='container p-5'>
					<div class='row'>
						<div class='col-12'>
							<h1 class='display-1'>GEONIUS™</h1>
							<p class='lead'>Know where, know first, know more.</p>
						</div>
					</div>


					<div class='row'>
						<div class='col-12'>
							{#if !loginFormVisible}

								<button class='btn bg-primary btn-lg' on:click={() => {
									loginFormVisible = !loginFormVisible;
								}}>Login</button>

							{:else}
								<LoginPanel />
							{/if}
						</div>
					</div>
				</div>
			</div>
			<div id="footer">
				<p>&copy; <a href='https://www.geollect.com' target='new'>Geollect</a></p>
			</div>
		</div> -->

	{/if}
</div>
